import React, { FC, SVGAttributes } from 'react'

const FaqPlusIcon: FC<SVGAttributes<SVGElement>> = ({ ...props }) => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M12 6V18M18 12H6" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

export default FaqPlusIcon
